import {Inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable, shareReplay} from 'rxjs';
import {AccountType} from '@ee/common/enums';
import {ProductResponse} from './models/product-reponse.model';

export type Term = 'annual' | 'monthly';

@Injectable({providedIn: 'root'})
export class PricingService {
  public resourceUrl = this.environment.api_prefix + 'api/billing/products';
  private products$: Observable<ProductResponse>;
  private selectedPrice: BehaviorSubject<Term> = new BehaviorSubject('annual');
  public selectedPrice$ = this.selectedPrice.asObservable();

  constructor(private http: HttpClient, @Inject('environment') private environment) {
  }

  updateTerm(term: Term) {
    this.selectedPrice.next(term);
  }

  getProducts(accountType: AccountType): Observable<ProductResponse> {
    if (!this.products$) {
      this.products$ = this.http.get<ProductResponse>(`${this.resourceUrl}/${accountType}`).pipe(
        shareReplay(1) // Cache the response and share it among subscribers
      );
    }
    return this.products$;
  }
}
